var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: { "grid-list-md": _vm.isMobile, "grid-list-lg": !_vm.isMobile },
      attrs: { "px-0": "" }
    },
    [
      _c(
        "v-form",
        { ref: "serviceInformation" },
        [
          !_vm.isAbsent && (_vm.relevantStudentBehavior || _vm.isDisplayAll)
            ? _c("checkbox-list", {
                attrs: {
                  items: _vm.sessionBehaviors,
                  label: "Relevant Student Behavior",
                  placeholder:
                    "Select behavior(s) observed during this session.",
                  validation: _vm.v.ptSessionBehaviors,
                  values:
                    _vm.student.form.serviceInformation.ptSessionBehaviors,
                  "reset-id": _vm.isCopying
                },
                on: {
                  update: function(v) {
                    return (_vm.student.form.serviceInformation.ptSessionBehaviors = v)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "v-flex",
                { staticClass: "text-xs-right", attrs: { xs12: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "margin-bottom": "-6px" },
                      attrs: {
                        slot: "activator",
                        round: "",
                        color: "secondary",
                        disabled:
                          _vm.student.form.serviceInformation
                            .ptSessionObjectives.length >= 3
                      },
                      on: { click: _vm.addObjective },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v("\n        New Objective\n      ")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "v-flex",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { xs12: "", sm8: "" }
                },
                [_c("h4", [_vm._v("Objective Note")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.combinedArray, function(item, index) {
            return !_vm.isAbsent && _vm.signature && _vm.objectivesIsProcessed
              ? _c(
                  "v-flex",
                  { key: index, attrs: { xs12: "" } },
                  [
                    _c("objective-repeatable", {
                      attrs: {
                        v: _vm.v,
                        student: _vm.student,
                        sessionObjectives: _vm.sessionObjectives,
                        sessionImplementations: _vm.sessionImplementations,
                        showTooltip: _vm.showTooltip,
                        index: index,
                        record: item.ptSessionObjectives,
                        record2: item.ptSessionObjectiveImplementation,
                        isCopying: _vm.isCopying
                      },
                      on: {
                        "delete:record": function($event) {
                          return _vm.removeObjectiveRecord(index)
                        },
                        "update:record": function($event) {
                          return _vm.updateRecord(index, $event)
                        },
                        "update:record2": function($event) {
                          return _vm.updateRecord2(index, $event)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _vm.objectiveNote && !_vm.isAbsent && _vm.signature
                ? _c("v-textarea", {
                    attrs: {
                      label: "Objective Details",
                      placeholder: "Enter Objective Details"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var hasValue = ref.hasValue
                            var isFocused = ref.isFocused
                            return undefined
                          }
                        }
                      ],
                      null,
                      false,
                      1183651906
                    ),
                    model: {
                      value: _vm.student.form.serviceInformation.objectiveNotes,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "objectiveNotes",
                          $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.objectiveNotes"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "v-flex",
                { staticClass: "text-xs-right", attrs: { xs12: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "margin-bottom": "-6px" },
                      attrs: {
                        slot: "activator",
                        round: "",
                        color: "secondary",
                        disabled:
                          _vm.student.form.serviceInformation
                            .ptSessionProgresses.length >= 3
                      },
                      on: { click: _vm.addTask },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v("mdi-plus")
                      ]),
                      _vm._v("\n        New Task\n      ")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "v-flex",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { xs12: "", sm8: "" }
                },
                [_c("h4", [_vm._v("Assessment of Performance/Progress")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(
            _vm.student.form.serviceInformation.ptSessionProgresses,
            function(item, index) {
              return !_vm.isAbsent && _vm.signature
                ? _c(
                    "v-flex",
                    { key: index, attrs: { xs12: "" } },
                    [
                      _c("progress-repeatable", {
                        attrs: {
                          v: _vm.v,
                          student: _vm.student,
                          sessionAssistTypes: _vm.sessionAssistTypes,
                          showTooltip: _vm.showTooltip,
                          index: index,
                          record: item,
                          action: _vm.action
                        },
                        on: {
                          "delete:record": function($event) {
                            return _vm.removeProgressRecord(index)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            }
          ),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "v-flex",
                [
                  _c("v-textarea", {
                    attrs: {
                      label: "Performance/Progress Notes",
                      placeholder: "Enter Performance/Progress Notes"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var hasValue = ref.hasValue
                            var isFocused = ref.isFocused
                            return undefined
                          }
                        }
                      ],
                      null,
                      false,
                      1183651906
                    ),
                    model: {
                      value:
                        _vm.student.form.serviceInformation.progressAssessment,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "progressAssessment",
                          $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.progressAssessment"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "div",
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "margin-bottom": "25px" },
                      attrs: { xs12: "", sm8: "" }
                    },
                    [
                      _c("h4", [
                        _vm._v("Proposed Plan and Target For Upcoming Services")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-textarea", {
                    attrs: {
                      label: "Next Session Focus(es)",
                      placeholder: "Enter Next Session Focus(es)",
                      "error-messages": _vm.sessionFocusErrors
                    },
                    on: {
                      blur: function($event) {
                        return _vm.handleTextTrimmingRequired(
                          "nextSessionFocus",
                          _vm.student.form.serviceInformation.nextSessionFocus
                        )
                      }
                    },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.nextSessionFocus,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "nextSessionFocus",
                          $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.nextSessionFocus"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-textarea", {
                    attrs: {
                      label: "Next Session Goal(s)",
                      placeholder: "Enter Next Session Goal(s)",
                      "error-messages": _vm.sessionGoalErrors
                    },
                    on: {
                      blur: function($event) {
                        return _vm.handleTextTrimmingRequired(
                          "nextSessionGoal",
                          _vm.student.form.serviceInformation.nextSessionGoal
                        )
                      }
                    },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.nextSessionGoal,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "nextSessionGoal",
                          $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.nextSessionGoal"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAbsent && _vm.signature
            ? _c(
                "div",
                [
                  _c("v-textarea", {
                    attrs: {
                      label: "Session Notes",
                      placeholder: "Enter Session Notes"
                    },
                    on: {
                      blur: function($event) {
                        return _vm.handleTextTrimming(
                          "sessionNotes",
                          _vm.student.form.serviceInformation.sessionNotes
                        )
                      }
                    },
                    model: {
                      value: _vm.student.form.serviceInformation.sessionNotes,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "sessionNotes",
                          $$v
                        )
                      },
                      expression: "student.form.serviceInformation.sessionNotes"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.action !== "edit" && _vm.action !== "copy" && _vm.signature
            ? _c(
                "div",
                [
                  _c("v-checkbox", {
                    attrs: {
                      id: "userCheckBox",
                      disabled: _vm.providerDisabled(),
                      color: "indigo darken-3",
                      "error-messages": _vm.checkedErrors,
                      messages: _vm.checkedCreate
                        ? this.student.form.serviceInformation
                            .licenseAttestName +
                          " " +
                          _vm.getCurrentDate()
                        : "",
                      label: "Provider Signature"
                    },
                    on: { change: _vm.onUserCheckboxClicked },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.licenseAttestUserId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "licenseAttestUserId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.licenseAttestUserId"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.action === "copy" && _vm.signature
            ? _c(
                "div",
                [
                  _c("v-checkbox", {
                    key: _vm.componentKey,
                    attrs: {
                      id: "userCheckBoxCopy",
                      disabled: _vm.disabledCopy,
                      color: "indigo darken-3",
                      "error-messages": _vm.checkedErrors,
                      messages: _vm.providerCheckCopy
                        ? this.student.form.serviceInformation
                            .licenseAttestName +
                          " " +
                          _vm.getCurrentDate()
                        : "",
                      label: "Provider Signature"
                    },
                    on: { change: _vm.onUserCheckboxClickedCopy },
                    model: {
                      value: _vm.providerCheckCopy,
                      callback: function($$v) {
                        _vm.providerCheckCopy =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "providerCheckCopy"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.action === "edit" &&
          this.supervisorFlagsArray.licenseAttestName &&
          _vm.signature
            ? _c(
                "div",
                [
                  _c("v-checkbox", {
                    attrs: {
                      id: "userCheckBox",
                      disabled: _vm.providerDisabled(),
                      color: "indigo darken-3",
                      "error-messages": _vm.checkedErrors,
                      messages: !_vm.checked
                        ? "" +
                          (this.student.form.serviceInformation
                            .licenseAttestName
                            ? this.student.form.serviceInformation
                                .licenseAttestName
                            : this.supervisorFlagsArray.licenseAttestName) +
                          " " +
                          _vm.convertDisplayedDate(
                            this.student.form.serviceInformation
                              .licenseAttestDate
                          )
                        : "",
                      label: "Provider Signature"
                    },
                    on: { change: _vm.onUserCheckboxClicked },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.licenseAttestUserId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "licenseAttestUserId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.licenseAttestUserId"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.action === "edit" &&
          !this.supervisorFlagsArray.licenseAttestName &&
          _vm.signature
            ? _c(
                "div",
                [
                  _c("v-checkbox", {
                    attrs: {
                      id: "userCheckBox",
                      disabled: _vm.providerDisabled(),
                      color: "indigo darken-3",
                      "error-messages": _vm.checkedErrors,
                      messages: _vm.checked
                        ? _vm.student.form.serviceInformation
                            .licenseAttestName +
                          " " +
                          _vm.getCurrentDate()
                        : "",
                      label: "Provider Signature"
                    },
                    on: { change: _vm.onUserCheckboxClicked },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.licenseAttestUserId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "licenseAttestUserId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.licenseAttestUserId"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.action === "edit" &&
          !this.supervisorFlagsArray.supervisorFlag &&
          this.supervisorFlagsArray.supervisorRequiredFlag &&
          _vm.signature
            ? _c(
                "div",
                [
                  _c("v-checkbox", {
                    attrs: {
                      id: "supervisorCheckBox",
                      disabled: _vm.supervisorDisabled,
                      color: "indigo darken-3",
                      "error-messages": _vm.supervisorCheckedErrors,
                      messages: _vm.supervisorChecked2
                        ? this.student.form.serviceInformation.supervisorName +
                          ", " +
                          this.student.form.serviceInformation
                            .supervisorCredential +
                          " " +
                          _vm.getCurrentDate()
                        : "",
                      label: "Supervision Signature"
                    },
                    on: { change: _vm.onSupervisorCheckboxClicked2 },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.supervisorUserId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "supervisorUserId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.supervisorUserId"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.action === "edit" &&
          this.supervisorFlagsArray.supervisorFlag &&
          this.supervisorFlagsArray.supervisorRequiredFlag &&
          _vm.signature
            ? _c(
                "div",
                [
                  _c("v-checkbox", {
                    attrs: {
                      id: "supervisorCheckBox",
                      disabled: _vm.supervisorDisabled2,
                      color: "indigo darken-3",
                      "error-messages": _vm.supervisorCheckedErrors,
                      messages: _vm.supervisorChecked
                        ? this.student.form.serviceInformation.supervisorName +
                          ", " +
                          _vm.supervisorCredentialFill() +
                          " " +
                          _vm.calcDate()
                        : "",
                      label: "Supervision Signature"
                    },
                    on: { change: _vm.onSupervisorCheckboxClicked },
                    model: {
                      value:
                        _vm.student.form.serviceInformation.supervisorUserId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "supervisorUserId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.supervisorUserId"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5387ebe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5387ebe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/extended-service-information.vue
// module id = null
// module chunks = 